import React from 'react';
import './index.css';
const isClone = (index, content, isInfinite) => {
    return isInfinite && (index === 0 || index === content.length - 1);
};
class List extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.getProps = (index) => {
            const { padding, axis, current } = this.props;
            const hasMargin = padding && padding > 0;
            return {
                ifeng_ui_mobile_sliders_margin: hasMargin ? 'yes' : 'no',
                'ifeng_ui_mobile_sliders-item': axis,
                'ifeng_ui_mobile_sliders-current': current + 1 === index ? 'true' : 'false',
            };
        };
    }
    render() {
        const { content, unitSize, tmpl, isInfinite, axis } = this.props;
        const sizeType = axis === 'horizonta' ? 'width' : 'height';
        return [
            ...content.map((item, index) => (React.createElement("div", Object.assign({ key: item.key ? item.key : index }, this.getProps(index), { style: { [sizeType]: unitSize } }), tmpl(item, isClone(index, content, isInfinite), index)))),
        ];
    }
}
export default List;
